import React, { useEffect, useRef, useState } from 'react';
import {
  Typography,
  Card,
  Tooltip,
  Switch,
  FormControl,
  InputLabel,
  Select as MUISelect,
  MenuItem,
  LinearProgress,
  TextField,
} from '@mui/material';
import './ProjectCard.css';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import DoneIcon from '@mui/icons-material/Done';
import IconButton from '@mui/material/IconButton';
import WarningIcon from '@mui/icons-material/Warning';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import AddResourceComponent from './ProjectResource/AddResourceComponent';
import CloseIcon from '@mui/icons-material/Close';
import {
  getEmployeesInProject,
  getProjectById,
  updateProjectsAndEmployees,
} from '../../services/ProjectService';
import { getUserData } from '../../services/UserService';
import moment from 'moment';
import { Box } from '@mui/system';
import {
  CONTINUE_CONFIRMATION,
  NO_TEXT,
  PROJECT_CONFIRMATION_ACTIVE,
  PROJECT_CONFIRMATION_INACTIVE,
  RESOURCE_HEADING,
  ROLE_OPTION_MANAGER,
  ROLE_OPTION_NON_MANAGER,
  WARNING_TEXT_FIRST,
  WARNING_TEXT_SECOND,
  YES_TEXT,
} from './ProjectConstants';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch } from 'react-redux';
import { SHOW_NOTIFICATION, UserType } from '../../constants';
import { DialogBoxComponent } from '../DialogBox/DialogBoxCard';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import KeycloakService from '../../services/KeycloakService';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const ProjectCardComponent2 = (props) => {
  const { setPage, project, reloadProjects } = props;
  const selectNameRef = useRef();
  const [loading, setLoading] = useState(true);
  const [addExpand, setAddExpand] = useState(false);
  const [warning, setWarning] = useState(false);
  const [projectUsers, setProjectUsers] = React.useState([]);
  const [oneProject, setOneProject] = React.useState({});
  const [editableResource, setEditableResource] = React.useState(false);
  const [editableId, setEditableId] = React.useState('');
  const [role, setRole] = useState();
  const [empstartDate, setEmpStartDate] = useState();
  const [loadTable, setLoadTable] = useState(true);
  const [statusChanged, setStatusChanged] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const [opens, setOpens] = React.useState(false);
  const dispatch = useDispatch();
  const [isDateValid, setIsDateValid] = useState(true);
  const [error, setError] = React.useState(null);

  const errorMessage = React.useMemo(() => {
    switch (error) {
      case 'invalidDate': {
        setIsDateValid(false);
        return 'Invalid date';
      }
      case 'minDate': {
        setIsDateValid(false);
        return 'Start date cannot be before the project start date';
      }
      default: {
        setIsDateValid(true);
        return '';
      }
    }
  }, [error]);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    getProject();
    const EmployeesInProject = await getEmployeesInProject(project.projectId);
    if (EmployeesInProject.isError === false) {
      setProjectUsers((prevUsers) => [
        ...EmployeesInProject.data.content.sort((a, b) => {
          if (a.status === 'ACTIVE' && b.status !== 'ACTIVE') return -1;
          if (a.status !== 'ACTIVE' && b.status === 'ACTIVE') return 1;
          return 0;
        }),
      ]);
    }
    if (EmployeesInProject.status !== 200) {
      dipatchNotification(EmployeesInProject.type, EmployeesInProject.message);
    }
  };
  const getProject = async () => {
    const singleProject = await getProjectById(project.projectId, '', '');
    if (singleProject.isError === false) {
      setOneProject(singleProject.data.content[0]);
      setLoading(false);
      setLoadTable(false);
    }
    if (singleProject.status !== 200) {
      dipatchNotification(singleProject.type, singleProject.message);
    }
  };

  const handleChange = (event) => {
    setRole(event.target.value);
  };

  const handleDateChange = (event) => {
    setEmpStartDate(event);
  };

  const toggleEmployeeStatus = (resource) => {
    handleClickOpen(resource);
  };

  const changeEmployeePayload = async (resource) => {
    const toUpdateUser = await getUserData(resource.employeeId);
    if (toUpdateUser.isError === false) {
      const st = resource.status === 'ACTIVE' ? 'ENDED' : 'ACTIVE';
      const end =
        resource.status === 'ACTIVE'
          ? moment(new Date()).format('YYYY-MM-DD')
          : null;
      return {
        projectEmployeeRelationDTOList: [
          {
            id: resource.id,
            projectId: project.projectId,
            projectName: project.projectName,
            employeeName: resource.employeeName,
            employeeId: resource.employeeId,
            email: toUpdateUser.data.emailId,
            isManager: resource.isManager,
            status: st,
            startDate: resource.startDate,
            endDate: end,
          },
        ],
      };
    }
    dipatchNotification(toUpdateUser.type, toUpdateUser.message);
  };

  const toggleEditable = async (resource) => {
    if (editableResource) {
      const projectStartDate = oneProject.startDate || project.startDate;
      if (
        projectStartDate &&
        (!empstartDate ||
          dayjs(empstartDate).isBefore(dayjs(projectStartDate), 'day'))
      ) {
        setError('minDate');
        dipatchNotification(
          'error',
          'Employee start date cannot be before the project start date.',
        );
        return;
      }
      if (!isDateValid) return;
      setLoadTable(true);
      const updatedPayload = await updateEmployeePayload(resource);
      console.log(updatedPayload);
      if (!updatedPayload.isError) {
        const updateResponse = await updateProjectsAndEmployees(updatedPayload);
        console.log(updatedPayload);
        if (!updateResponse.isError) {
          setEditableId('');
          setRole(resource.isManager ? 'Manager' : 'Team Member');
          loadData();
          setLoadTable(false);
          reloadProjects();
          setEditableResource(!editableResource);
        }
        dipatchNotification(updateResponse.type, updateResponse.message);
        setPage(1);
      }
    } else {
      setRole(resource.isManager ? 'Manager' : 'Team Member');
      setEmpStartDate(resource.startDate);
      setEditableId(resource.id);
      setEditableResource(!editableResource);
    }
  };

  const cancelEditable = () => {
    setEditableResource(false);
  };

  const toggleEditableCheck = (resource) => {
    setEditableId(resource.id);
    setRole(resource.isManager ? 'Manager' : 'Team Member');
    setEmpStartDate(resource.startDate);
  };

  const handleCloseYes = () => {
    setOpen(false);
    changeStatusFunction(statusChanged);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleActiveProject = () => {
    setOpens(false);
    toggleProjectStatus();
  };

  const handleInactiveProject = () => {
    setOpens(false);
  };

  const updateEmployeePayload = (resource) => {
    return {
      projectEmployeeRelationDTOList: [
        {
          id: resource.id,
          projectId: project.projectId,
          projectName: project.projectName,
          employeeName: resource.employeeName,
          employeeId: resource.employeeId,
          email: resource.email,
          isManager: role === 'Manager',
          status: 'ACTIVE',
          startDate: moment(new Date(empstartDate)).format('YYYY-MM-DD'),
          endDate: null,
        },
      ],
    };
  };

  const handleClickOpen = (resource) => {
    setStatusChanged(resource);
    setOpen(true);
  };

  const columns = [
    {
      field: 'employeeName',
      headerName: 'Name',
      flex: 0.8,
      renderCell: (params) =>
        params.row.status === 'ACTIVE' ? (
          <Typography>{params.row.employeeName}</Typography>
        ) : (
          <Typography sx={{ color: 'gray' }}>
            {params.row.employeeName}
          </Typography>
        ),
    },
    {
      field: 'isManager',
      headerName: 'Role',
      flex: 0.5,
      valueGetter: (params) =>
        params.row.isManager ? 'Manager' : 'Team Member',
      renderCell: (params) => (
        <>
          {params.row.status === 'ACTIVE' ? (
            editableResource ? (
              params.row.id === editableId ? (
                <FormControl size="small">
                  <InputLabel id="demo-simple-select-label">Role</InputLabel>
                  <MUISelect
                    labelId="demo-simple-select-label"
                    label="Role"
                    defaultValue={role}
                    onChange={(e) => handleChange(e)}
                  >
                    <MenuItem value={ROLE_OPTION_NON_MANAGER}>
                      {ROLE_OPTION_NON_MANAGER}
                    </MenuItem>
                    <MenuItem value={ROLE_OPTION_MANAGER}>
                      {ROLE_OPTION_MANAGER}
                    </MenuItem>
                  </MUISelect>
                </FormControl>
              ) : (
                <Typography>
                  {params.row.isManager ? 'Manager' : 'Team Member'}
                </Typography>
              )
            ) : (
              <Typography>
                {params.row.isManager ? 'Manager' : 'Team Member'}
              </Typography>
            )
          ) : (
            <Typography sx={{ color: 'gray' }}>
              {params.row.isManager ? 'Manager' : 'Team Member'}
            </Typography>
          )}
        </>
      ),
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      flex: 0.5,
      renderCell: (params) =>
        params.row.status === 'ACTIVE' ? (
          editableResource ? (
            params.row.id === editableId ? (
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                sx={{ display: 'none' }}
              >
                <DatePicker
                  onError={(newError) => setError(newError)}
                  inputFormat="YYYY-MM-DD"
                  value={empstartDate}
                  onChange={(e) => handleDateChange(e)}
                  minDate={
                    oneProject.startDate
                      ? dayjs(oneProject.startDate)
                      : undefined
                  }
                  sx={{
                    '& .MuiTextField-root': {
                      width: '10rem',
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      sx={{
                        '& .MuiInputBase-formControl': {
                          height: '42px',
                        },
                      }}
                      {...params}
                      error={!isDateValid}
                      helperText={errorMessage}
                    />
                  )}
                />
              </LocalizationProvider>
            ) : (
              <Typography>{params.row.startDate}</Typography>
            )
          ) : (
            <Typography>{params.row.startDate}</Typography>
          )
        ) : (
          <Typography sx={{ color: 'gray' }}>{params.row.startDate}</Typography>
        ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.3,
      sortable: false,
      renderCell: (params) => (
        <>
          <Switch
            size="small"
            checked={params.row.status === 'ACTIVE'}
            onChange={() => {
              toggleEmployeeStatus(params.row);
            }}
            disabled={
              oneProject.projectStatus === 'ACTIVE'
                ? !KeycloakService.hasRole([UserType.ADMIN]) &&
                  !KeycloakService.hasRole([UserType.MANAGER])
                : true
            }
          />
          {params.row.status === 'ACTIVE' ? (
            <>
              {editableResource ? (
                params.row.id === editableId ? (
                  <>
                    <IconButton
                      color="secondary"
                      onClick={() => toggleEditable(params.row)}
                    >
                      <SaveIcon />
                    </IconButton>
                    <IconButton
                      sx={{ ml: -1 }}
                      color="error"
                      onClick={() => cancelEditable()}
                    >
                      <CloseIcon />
                    </IconButton>
                  </>
                ) : (
                  <IconButton
                    color="secondary"
                    onClick={() => toggleEditableCheck(params.row)}
                  >
                    <EditIcon />
                  </IconButton>
                )
              ) : (
                <IconButton
                  color="secondary"
                  onClick={() => toggleEditable(params.row)}
                  disabled={oneProject.projectStatus !== 'ACTIVE'}
                >
                  <EditIcon />
                </IconButton>
              )}
            </>
          ) : (
            ''
          )}
        </>
      ),
    },
  ];

  const addEmployeePayload = async (id, role) => {
    const user = await getUserData(id);
    if (user.isError === false) {
      const projectStartDate = oneProject.startDate || project.startDate;
      let startDate = moment().startOf('day');
      if (projectStartDate && moment(projectStartDate).isAfter(startDate, 'day')) {
        startDate = moment(projectStartDate).startOf('day');
      }
      return {
        projectEmployeeRelationDTOList: [
          {
            projectId: project.projectId,
            projectName: project.projectName,
            employeeName: user.data.firstName + ' ' + user.data?.lastName || '',
            employeeId: id,
            email: user.data.emailId,
            isManager: role === 'Manager',
            status: 'ACTIVE',
            startDate: startDate.format('YYYY-MM-DD'),
            endDate: null,
          },
        ],
      };
    }
    if (user.status !== 200) {
      dipatchNotification(user.type, user.message);
    }
  };

  const changeProjectPayload = () => {
    const st = oneProject.projectStatus === 'ACTIVE' ? 'ENDED' : 'ACTIVE';
    return {
      id: oneProject.id,
      projectName: oneProject.projectName,
      projectStatus: st,
      startDate: oneProject.startDate,
      description: oneProject.description,
    };
  };

  const ScrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const handleSubmit = async () => {
    if (
      selectNameRef.current.name === undefined ||
      selectNameRef.current.role === 'None'
    ) {
      setWarning(true);
    } else {
      setLoadTable(true);
      const payload = await addEmployeePayload(
        selectNameRef.current.id,
        selectNameRef.current.role,
      );
      const postResponse = await updateProjectsAndEmployees(payload);
      if (postResponse.isError === false) {
        loadData();
        toggleAddResource();
        setLoadTable(false);
      } else {
        loadData();
      }
      dipatchNotification(postResponse.type, postResponse.message);
    }
  };

  const changeStatusFunction = async (resource) => {
    setLoadTable(true);
    const changedPayload = await changeEmployeePayload(resource);
    const updateResponse = await updateProjectsAndEmployees(changedPayload);
    if (updateResponse.isError === false) {
      loadData();
      setLoadTable(false);
    }
    dipatchNotification(updateResponse.type, updateResponse.message);
  };

  const toggleAddResource = () => {
    setAddExpand(!addExpand);
    setWarning(false);
  };

  const toggleProjectStatus = async () => {
    const projectPayload = changeProjectPayload();
    const updateResponse = await updateProjectsAndEmployees(projectPayload);
    if (updateResponse.isError === false) {
      loadData();
    }
    dipatchNotification(updateResponse.type, updateResponse.message);
  };
  return (
    <Card variant="outlined" sx={{ mb: 1 }}>
      {loading ? (
        ''
      ) : (
        <Box>
          <Box className="project-container" style={{ overflow: 'auto' }}>
            <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box style={{ display: 'flex', alignItems: 'flex-start' }}>
                <Typography
                  variant="h6"
                  noWrap
                  sx={{
                    fontFamily: 'sans-serif',
                    fontSize: '1.7rem',
                    textTransform: 'capitalize',
                    color:
                      oneProject.projectStatus !== 'ACTIVE' ? 'gray' : 'navy',
                    marginBottom: '0.8rem',
                  }}
                >
                  {project.projectName}
                </Typography>
              </Box>
              <Box>
                {addExpand ? (
                  <IconButton
                    sx={{ paddingBottom: 1.6, display: 'none' }}
                    color="primary"
                    onClick={() => {
                      toggleAddResource();
                    }}
                  >
                    <PersonAddAltIcon />
                  </IconButton>
                ) : (
                  <Tooltip title="Add Employees" arrow>
                    <IconButton
                      sx={{ paddingBottom: 1.6 }}
                      color="primary"
                      onClick={() => {
                        toggleAddResource();
                      }}
                      disabled={oneProject.projectStatus !== 'ACTIVE'}
                    >
                      <PersonAddAltIcon />
                    </IconButton>
                  </Tooltip>
                )}
                <DialogBoxComponent
                  open={opens}
                  handleClose={handleClose}
                  confirmText={YES_TEXT}
                  cancelText={NO_TEXT}
                  content={
                    (oneProject.projectStatus === 'ACTIVE'
                      ? PROJECT_CONFIRMATION_INACTIVE
                      : PROJECT_CONFIRMATION_ACTIVE) +
                    oneProject.projectName +
                    CONTINUE_CONFIRMATION
                  }
                  onConfirm={handleActiveProject}
                  onCancel={handleInactiveProject}
                  icon={<WarningIcon color="warning" />}
                />
              </Box>
            </Box>
            {!addExpand ? (
              ''
            ) : (
              <Box
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}
              >
                <Box style={{ flexBasis: '70%' }}>
                  <AddResourceComponent
                    ref={selectNameRef}
                    currentProjectEmployees={projectUsers}
                  />
                  {warning ? (
                    <Box style={{ color: 'red' }}>
                      <small>Please Enter a valid name and role</small>
                    </Box>
                  ) : (
                    ''
                  )}
                </Box>
                <Box>
                  <IconButton
                    color="success"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    <DoneIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => {
                      toggleAddResource();
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Box>
            )}
            <Box
              className="project-card-subhead"
              sx={{
                color: oneProject.projectStatus !== 'ACTIVE' ? 'gray' : '',
              }}
            >
              <strong>{RESOURCE_HEADING}</strong>
            </Box>
            <Box style={{ height: '350px' }}>
              <DataGrid
                sx={{
                  color: oneProject.projectStatus !== 'ACTIVE' ? 'gray' : '',
                  '& .MuiDataGrid-columnHeader': {
                    position: 'relative',
                  },
                  '& .MuiDataGrid-menuIcon, & .MuiDataGrid-menuIconButton': {
                    visibility: 'visible !important',
                    opacity: '1 !important',
                    position: 'absolute',
                    right: '0.5rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                  },
                  '& .MuiDataGrid-sortIcon': {
                    visibility: 'visible !important',
                    opacity: '1 !important',
                    position: 'absolute',
                    left: '0',
                    top: '50%',
                    transform: 'translateY(-50%)',
                  },

                  '& .MuiDataGrid-columnHeaderTitleContainer': {
                    paddingRight: '50px',
                  },

                  '& .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIconButton, & .MuiDataGrid-columnHeader:hover .MuiDataGrid-sortIcon':
                    {
                      visibility: 'visible !important',
                      opacity: '1 !important',
                      position: 'absolute',
                    },
                }}
                rows={projectUsers}
                columns={columns}
                hideFooter
                components={{
                  LoadingOverlay: LinearProgress,
                }}
                loading={loadTable}
              />
              <DialogBoxComponent
                open={open}
                handleClose={handleClose}
                content={`${WARNING_TEXT_FIRST}
                            ${
                              statusChanged.status === 'ACTIVE'
                                ? 'remove ' +
                                  statusChanged.employeeName +
                                  ' from ' +
                                  project.projectName
                                : 're-assign ' +
                                  statusChanged.employeeName +
                                  ' to ' +
                                  project.projectName
                            }
                          ${WARNING_TEXT_SECOND}`}
                icon={<WarningAmberIcon color="warning" />}
                onConfirm={handleCloseYes}
                onCancel={handleClose}
                confirmText={YES_TEXT}
                cancelText={NO_TEXT}
              />
            </Box>
          </Box>
        </Box>
      )}
    </Card>
  );
};

export default ProjectCardComponent2;
